module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAF1thSHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAChSURBVHjaYvz//z8DDDAxMDAwePf++M/AwMAAAAAA//9ihMmwwEQAAAAA//9i/P//P1yagYGBYWsxByMjsgEwAAAAAP//whCEmwzTzkRQCwAAAP//wmowOmBiIAKwwBjIbkf2A9HWAQAAAP//IqiIiSi3YHMH3vAkyQQm2vsCAAAA//8iKrCIjhZ8HsLlSZISwNDxDlVcQpUwAQAAAP//AwAWc01LRZmfPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/node_modules/@ngx-ivengi/cleanzone/theme/images/cleanzone/stat-same.png
// module id = ../../../../@ngx-ivengi/cleanzone/theme/images/cleanzone/stat-same.png
// module chunks = styles